module.exports = __webpack_public_path__ + "static/media/ms.d5390a0c.svg";